module.exports = __webpack_public_path__ + "img/building.ae7d6d6b.png";